import SearchModalV2 from './SearchModalV2'

const SearchModal = (props) => {
  return <SearchModalV2 {...props} /> // : <SearchModalV1 {...props} />
}

export default SearchModal
